import { useCallback } from 'react';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';

import { getAllBeneficiaries } from '@/features/beneficiaries/store/actions/all-beneficiaries.actions';
import { IFilterBeneficiary } from '@/features/beneficiaries/store/models/beneficiary.model';
import { TBeneficiaryAction } from '@/features/beneficiaries/hooks/AllBeneficiaries/useUserBeneficiariesData';

export function useAllBeneficiariesData() {
  const dispatch = useAppDispatch();

  const { beneficiaries, isLoading, meta } = useAppSelector((state) => state?.allBeneficiaries);

  const getData = useCallback(
    (filter: IFilterBeneficiary) => {
      dispatch(
        getAllBeneficiaries({
          ...filter,
        }),
      );
    },
    [dispatch],
  );

  const actions: TBeneficiaryAction[] = ['redirect'];

  return { data: { beneficiaries, isLoading, meta }, getData, actions };
}
